module.exports = "/assets/ddd9af8f6ac9685b0db2ddd56ffc796e.png";